import React, { useContext, useEffect } from "react";
import "../../utils/css/landingMain.scss";
import { Row, Col, Container } from "react-bootstrap";
import LeftDiv from "./landingLeft";
import Rightdiv from "./landingRight";
import NavBar from "../../marginals/navBar";
import { Backdrop } from "@mui/material";
import { Button } from "react-bootstrap";
import { Context } from "../../../context/DataProvider";
import { trackEvent } from "../../../config/eventHandlers";
import { RELOGIN_URL } from "../../../utils/constants";
import { ScreenName } from "../../../config/constants";
import { getMbServerToken } from "../../../utils/cookieUtils";

export default function MainPage(props) {
  const { setBankSelected } = useContext(Context);
  setBankSelected(null);
  const page = "Reimbursement";
  useEffect(() => {
    trackEvent.homepageLanded({ screenName: ScreenName.HOMEPAGE });
  }, []);
  let access_token =
  getMbServerToken()?.trim() ||
  props.userLongToken ||
  false;

  return (
    <main>
      <NavBar page={page} redirect={""} userName={props.userName}  isLandingPage={true}/>
      <Container style={{ margin: "0px" }}>
        <div>
          <Container>
            {access_token ? (
              <div className="page-content">
              <Row style={{ display: "flex"}}>
                <Col
                  md={3}
                  sm={12}
                  xs={12}
                  className="nav-section left-sticky"
                
                >
                  <LeftDiv />
                </Col>
                <Col
                  md={9}
                  sm={12}
                  xs={12}
                  className="right-scroll"
                >
                  <Rightdiv accessToken={access_token} />
                </Col>
              </Row>
            </div>
            ) : (
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open
              >
                <div
                  style={{
                    width: "90%",
                    display: "flex",
                    flexDirection: "column",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "1rem",
                    background: "white",
                    borderRadius: "10px",
                    margin: "0 auto",
                    color: "black",
                    padding: "2rem",
                    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
                    maxWidth: 420,
                  }}
                >
                  <p
                    style={{
                      display: "inline",
                      alignItems: "center",
                      margin: "0px 10px",
                    }}
                  >
                    <strong>
                      {"You are unauthorized. Please signin to continue."}
                    </strong>
                  </p>
                  <Button
                    id="create-claim-btn"
                    variant="primary"
                    style={{
                      border: "blue",
                      cursor: "pointer",
                      text: "white",
                    }}
                    className={"border-radius-10"}
                    onClick={() => (window.location.href = RELOGIN_URL)}
                  >
                    Login
                  </Button>
                </div>
              </Backdrop>
            )}
          </Container>
        </div>
      </Container>
    </main>
  );
}
